import reduxStore from "../../../configureEnvStore";
import { cloneDeep } from "lodash";
import { toast } from "react-toastify";
import { NOTIFICATION_TYPES } from "../../../constants/DataTrackNotificationConstants";
import {
    setActiveuserlist,
    setAudioStartNotificationReceivedFromHostModalOpen,
    setIsAudioButtonClickDisable,
    setNewActiveUserlist,
    setOwnIndex,
    setRequestMicCameraModalsData,
    setScreenShareStartNotificationReceivedFromHostModalOpen,
    setTotalUserCount,
    setVideoStartNotificationReceivedFromHostModalOpen,
} from "../../../reducers/common-reducer";
import {
    addCallParticipant,
    handleReceiveVideoScreenShareDataTrack,
    sendBackToAllUserForOfflineModeNotSupported,
    showToastMessages,
    updateParticipantAudioInfo,
    updateParticipantNames,
    updateParticipantVideoInfo,
} from "../../../shared/dataTrackFunction";
import { dualStreamEnabled } from "../../../shared/utility";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../../../constants/PublicVariables";
import { BATTERY_CRITICAL_VALUE, DISABLE, ENABLED, LOCAL_STORAGE_KEYS, MEASUREMENT_VIEW } from "../../../constants/Constants";
import chatService from "../../../services/chatService";
import { changeVideoQuality } from "../../CallScreens/CallTopbar/CallSettings/CallSettingUtils";
import zoomService from "../../../services/zoomService";
import takePhotoService from "../../../services/takePhotoService";
import {
    handleRecordingErrorOnGuest,
    handleRecordingStartDatatrackMessage,
    handleRecordingStoppedDatatrackMessage,
} from "../../Recording/RecordingUtils";
import { LogFirebase } from "../../../services/firestore";
import livePointerService from "../../LivePointer/livePointerService";
import batteryInfoService from "../../../services/batteryInfoService";
import extractTextService from "../../../services/extractTextService";
import { handleUpdateUserNetworkType } from "../../Network/NetworkUtils";
import { handleUpdateUserLiveLocationInfo, showLatLongForStreaming } from "../../LiveLocation/LocationUtils";
import uploadFilesService from "../../../services/uploadFilesService";
import flashService from "../../../services/flashService";
import markupService from "../../../services/MarkupService/markupService";
import { screenShareOnOffStatus, showExpandView, showGridView, videoOnOffStatus } from "../../GalleryView/GalleryViewUtils";
import { setGuestVideoSubscriptionFailed } from "../../../reducers/track-failed-reducer";
import { showAgentVideoSubscriptionFailed } from "../Events/RoomEventsFunction/TrackSubscriptionFailed/handleTrackSubscriptionFailed";
import { AR_STATUS } from "../../../constants/MeasurementConstants";
import measurementService from "../../../services/measurementService";
import arMarkupService from "../../../services/MarkupService/arMarkupService";
import { handleEndCallFunc } from "../Room/roomFunction.js";
import CustomToast from "../../UI/customToast.js";
import Localize from "../../../locale/Localize.js";
import { handleToggleAudio } from "../AudioCall/AudioCallUtils.js";
import { handleStartStopVideo, performStartStopVideo } from "../VideoCall/VideoUtils.js";
import storage from "../../../services/storage.js";
import { FIREBASE_EVENT_CATEGORY } from "../../../constants/FirebaseConstants.js";
import {
    setIsOfflineModeActive,
    setIsOfflineModeInProgress,
    setLocalUserOfflineModeIdentity,
    setOfflineModeUserIdentity,
} from "../../../reducers/offline-mode-reducer.js";
import { offlineModeService } from "../../OfflineMode/offlienModeService.js";

export const handleReceivedDataTrack = (track) => {
    track.on("message", function (data) {
        let message = JSON.parse(data);
        console.log("DATA_TRACK_MESSAGE_RECEIVED: ", message, "Notification_type: ", message?.notification_type, message?.device_type);
        switch (message.notification_type) {
            case NOTIFICATION_TYPES.PARTICIPANT_JOINED:
                handleParticipantJoined(message);
                break;
            case NOTIFICATION_TYPES.HOST_TO_GUEST.REMOVE_USER:
                handleRemoveParticipantByHost(message);
                break;
            case NOTIFICATION_TYPES.HOST_TO_GUEST.AUDIO_ON_OFF:
                handleMuteUnmuteAudioByHost(message);
                break;
            case NOTIFICATION_TYPES.REQUEST_PERMISSION_TO_AGENT_FOR_MIC_CAMERA_STRAT:
                handleRequestToAgentStartAudioOrVideo(message);
                break;
            case NOTIFICATION_TYPES.REQUESTED_MIC_PERMISSION_ACCEPTED_REJECTED_BY_AGENT:
                handleMicPermissionResponseByAgent(message);
                break;
            case NOTIFICATION_TYPES.REQUESTED_CAMERA_PERMISSION_ACCEPTED_REJECTED_BY_AGENT:
                handleCameraPermissionResponseByAgent(message);
                break;
            case NOTIFICATION_TYPES.HOST_TO_GUEST.VIDEO_START_STOP:
                handleStartStopVideoByHost(message);
                break;
            case NOTIFICATION_TYPES.HOST_TO_GUEST.SCREENSHARE_START_STOP:
                handleStartStopScreenshareByHost(message);
                break;
            case NOTIFICATION_TYPES.SCREENSHARE_STATUS:
                screenShareOnOffStatus(message);
                break;
            case NOTIFICATION_TYPES.VIDEO_STATUS:
                videoOnOffStatus(message);
                break;
            case NOTIFICATION_TYPES.CHAT_TEXT_MSG:
                handleChatMessage(message);
                break;
            case NOTIFICATION_TYPES.MICROPHONE_PERMISSION:
                handleMicrophonePermission(message);
                break;
            case NOTIFICATION_TYPES.CAMERA_PERMISSION:
                handleCameraPermission(message);
                break;
            case NOTIFICATION_TYPES.VIDEO_QUALITY:
                handleVideoQuality(message);
                break;
            case NOTIFICATION_TYPES.ZOOM_LEVEL.AGENT_TO_GUEST:
            case NOTIFICATION_TYPES.ZOOM_LEVEL.GUEST_TO_AGENT:
                handleZoomLevelChange(message);
                break;
            case NOTIFICATION_TYPES.VIDEO_SCREENSHARE_STATUS:
                handleVideoScreenShareTrack(message);
                break;
            case NOTIFICATION_TYPES.TAKE_PHOTO.TO_STREAMING_USER:
                handleTakePhotoRequestToStreamingUser(message);
                break;
            case NOTIFICATION_TYPES.TAKE_PHOTO.STREAMING_USER_TO_ALL:
                handleTakePhotoRequestFromStreamingUser(message);
                break;
            case NOTIFICATION_TYPES.EXTRACT_TEXT.AGENT_TO_ALL:
                handleOCRRequestToStreamingUser(message);
                break;
            case NOTIFICATION_TYPES.EXTRACT_TEXT.GUEST_TO_AGENT:
                handleOCRRequestFromStreamingUser(message);
                break;
            case NOTIFICATION_TYPES.RECORDING.START:
                LogFirebase("Recording", "StartMsgReceived", "");
                handleRecordingStartDatatrackMessage(message);
                break;
            case NOTIFICATION_TYPES.RECORDING.STOP:
                LogFirebase("Recording", "StopMsgReceived", "");
                handleRecordingStoppedDatatrackMessage(message);
                break;
            case NOTIFICATION_TYPES.RECORDING.START_ERROR:
                LogFirebase("Recording", "AgentCouldNotConnect", message);
                handleRecordingErrorOnGuest(message);
                break;
            case NOTIFICATION_TYPES.LIVEPOINTER.STATUS_START_STOP: // acknowledgment
                console.log("STATUS_START_STOP_Received_", message);
                livePointerService.toggleLivePointer(true, message);
                break;
            case NOTIFICATION_TYPES.LIVEPOINTER.POINT:
                livePointerService.moveLivePointerForRemote(message);
                break;
            case NOTIFICATION_TYPES.BATTERY_LOW_MESSAGE:
                if (GLOBAL_MEETING_DATA.isAgent) handleGuestDeviceBatteryInfo(message);
                break;
            case NOTIFICATION_TYPES.NETWORK_INFO:
                handleNetworkInformation(message);
                break;
            case NOTIFICATION_TYPES.LOCATION:
                handleUpdateUserLiveLocationInfo(message);
                break;
            case NOTIFICATION_TYPES.UPLOAD_FILE:
                uploadFilesService.handleUploadFileDataTrackMessage(message);
                break;
            case NOTIFICATION_TYPES.OFFLINE_MODE_UPLOAD_FILE:
                offlineModeService.handleUploadFileDataTrackMessage(message);
                break;
            case NOTIFICATION_TYPES.FLASHLIGHT.FROM_LOCAL:
                flashService.handleFlashDataTrackForLocal(message);
                break;
            case NOTIFICATION_TYPES.FLASHLIGHT.FROM_REMOTE:
                flashService.handleFlashDataTrackForRemote(message);
                break;
            case NOTIFICATION_TYPES.MARKUP.AGENT_TO_ALL:
                handleMarkupRequestToStreamingUser(message);
                break;
            case NOTIFICATION_TYPES.MARKUP.GUEST_TO_AGENT:
                handleMarkupRequestFromStreamingUser(message);
                break;
            case NOTIFICATION_TYPES.MULTI_STREAM.EXPAND:
                LogFirebase("MultiStream", "ExpandNotiReceived", message.expand_useridentity);
                showExpandView(message?.expand_useridentity, false);
                break;
            case NOTIFICATION_TYPES.MULTI_STREAM.COLLAPSE:
                LogFirebase("MultiStream", "CollapseNotiReceived", message.collapse_useridentity);
                showGridView(message.collapse_useridentity, false);
                break;
            case NOTIFICATION_TYPES.REMOTE_MARKUP:
                markupService.drawonlive(message);
                break;
            case NOTIFICATION_TYPES.MARKUP_LIVESTREAM.AGENT_TO_ALL:
                markupService.handleMarkupLiveStreamRequestToStreamingUser(message);
                break;
            case NOTIFICATION_TYPES.MARKUP_LIVESTREAM.GUEST_TO_AGENT:
                markupService.handleMarkupLiveStreamRequestFromStreamingUser(message);
                break;
            case NOTIFICATION_TYPES.REMOTE_MARKUP_LIVESTREAM:
                if (GLOBAL_MEETING_DATA.isAgent) {
                    //only agent will handle this to manage save btn
                    markupService.drawonlive(message);
                }
                break;
            case NOTIFICATION_TYPES.REMOTE_AR_MARKUP_LIVESTREAM:
                if (GLOBAL_MEETING_DATA.isAgent) markupService.drawonlive(message); //only agent will handle this to manage save btn
                break;
            case NOTIFICATION_TYPES.AR_MARKUP.GUEST_TO_AGENT:
                markupService.handleMarkupLiveStreamRequestFromStreamingUser(message);
                break;
            case NOTIFICATION_TYPES.AR_MARKUP.AGENT_TO_ALL:
                arMarkupService.handleARMarkupRequestToStreamingUser(message);
                break;
            case NOTIFICATION_TYPES.REMOTE_VIDEO.SUBSCRIPTION_FAILED:
                if (GLOBAL_MEETING_DATA.isAgent) {
                    showAgentVideoSubscriptionFailed(message);
                } else {
                    reduxStore.dispatch(setGuestVideoSubscriptionFailed(true));
                }
                break;
            case NOTIFICATION_TYPES.KNOW_MOBILE_APP_AR_STATUS:
                measurementService.handleUserMeasurementStatus(message);
                break;
            case NOTIFICATION_TYPES.MEASUREMENT_START_STOP:
                if (GLOBAL_MEETING_DATA.isAgent) {
                    measurementService.startStopMeasurement(message);
                } else if (message.measurement_status != AR_STATUS.AR_DEVICE_SUPPORTED_STATUS && !GLOBAL_MEETING_DATA.isAgent) {
                    const measurementStarted = reduxStore.getState().measurement.measurementStarted;
                    if (!(measurementStarted && message.measurement_status == AR_STATUS.STARTED_MEASUREMENT)) {
                        measurementService.startStopMeasurement(message);
                    }
                }
                break;
            case NOTIFICATION_TYPES.AR_MEASUREMENT.AGENT_TO_ALL:
                measurementService.handleMeasurementNotification(message);
                break;
            case NOTIFICATION_TYPES.AR_MEASUREMENT.GUEST_TO_AGENT: {
                const measurementView = reduxStore.getState().measurement.measurementView;
                if (
                    GLOBAL_MEETING_DATA.ucid &&
                    (measurementView === MEASUREMENT_VIEW.PREPARE_VIEW || measurementView === MEASUREMENT_VIEW.START_MEASUREMENT_VIEW)
                ) {
                    measurementService.handleMeasurementNotification(message);
                }

                if (arMarkupService.checkARMarkupIsOngoing()) {
                    arMarkupService.handleARMarkupToastMessage(message);
                }
                break;
            }
            case NOTIFICATION_TYPES.OFFLINE_MODE.START: {
                if (GLOBAL_MEETING_DATA.isGuest) {
                    offlineModeDataTrack(message);
                }
                break;
            }
            case NOTIFICATION_TYPES.OFFLINE_MODE.RECONNECT_USER: {
                handleRemoveOfflineModeUserIdentity(message);
                break;
            }
            case NOTIFICATION_TYPES.OFFLINE_MODE.PRIVATE_MODE_NOT_SUPPORTED: {
                if (message.identity != CALL_DATA.localIdentity) {
                    handleOfflineModeNotSupoortedForiOSPrivateModeUser(message);
                }
                break;
            }
            default:
                // Handle other notification types or provide default behavior
                break;
        }
    });
};

export const offlineModeDataTrack = (message) => {
    if (CALL_DATA.iOSPrivateMode && message?.offline_mode_user_identity == CALL_DATA.localIdentity) {
        const localisedValues = Localize[PublicVariables.currentLanguageObj.languageCode];
        CustomToast.info(
            localisedValues?.offline_uploads_are_not_supported_in_private_mode +
                " " +
                localisedValues?.please_switch_to_a_normal_browser_tab_to_use_this_feature
        );
        sendBackToAllUserForOfflineModeNotSupported();
        return;
    }
    CALL_DATA.isOfflineModeActive = true;
    const { offlineModeUserIdentity } = reduxStore.getState().offlineMode;
    reduxStore.dispatch(setOfflineModeUserIdentity([...offlineModeUserIdentity, message.offline_mode_user_identity]));
    if (CALL_DATA.localIdentity === message.offline_mode_user_identity) {
        LogFirebase("OfflineMode", "total_user_with_offline_mode_when_receive_data_track", {
            already_offline_started_user_identity: offlineModeUserIdentity,
            new_offline_mode_user_identity: message?.offline_mode_user_identity,
            total_user_with_offline_mode: [...offlineModeUserIdentity, message?.offline_mode_user_identity],
        });
        LogFirebase("OfflineMode", "Going_to_disconnect", { identity: message?.offline_mode_user_identity });
        reduxStore.dispatch(setIsOfflineModeInProgress(true)); // starting offline mode, start loader
        reduxStore.dispatch(setLocalUserOfflineModeIdentity(message.offline_mode_user_identity));
        handleEndCallFunc(); // End the call when offline mode is enabled
        reduxStore.dispatch(setIsOfflineModeActive(true)); // Update the Redux store
        setTimeout(() => {
            LogFirebase("OfflineMode", "Going_to_start_offline_mode", "true");
            uploadFilesService.showUploadFilesView(null);
            reduxStore.dispatch(setIsOfflineModeInProgress(false)); // started offline mode, hide loader
        }, 1200);
    }
};

export const handleRemoveOfflineModeUserIdentity = (message) => {
    if (message?.offline_mode_user_identity) {
        const { offlineModeUserIdentity } = reduxStore.getState().offlineMode;
        LogFirebase("OfflineMode", "total_user_with_offline_mode_when_RemoveOfflineModeUserIdentity", {
            already_offline_started_user_identity: offlineModeUserIdentity,
            new_offline_mode_user_identity: message?.offline_mode_user_identity,
        });
        const offlineDataUserId = offlineModeUserIdentity;
        const updatedCallParticipants = offlineDataUserId.filter((identity) => identity !== message?.offline_mode_user_identity);
        LogFirebase("OfflineMode", "check_offline_mode_user_count_RemoveIdentity_after_filter", updatedCallParticipants?.length);
        if (updatedCallParticipants.length === 0) {
            CALL_DATA.isOfflineModeActive = false; // Reset offline mode flag if no participants left
            LogFirebase("OfflineMode", "stop_offline_after_filter", "all_user_left_offline_mode");
        }
        reduxStore.dispatch(setOfflineModeUserIdentity(updatedCallParticipants));
    }
};

export const handleOfflineModeNotSupoortedForiOSPrivateModeUser = (message) => {
    if (message?.private_mode) {
        if (GLOBAL_MEETING_DATA.isAgent) {
            const localisedValues = Localize[PublicVariables.currentLanguageObj.languageCode];
            CustomToast.info(
                localisedValues?.guest_is_using_a_private_browser_window + " " + localisedValues?.offline_upload_mode_is_not_supported_in_this_case
            );
        }
        const { offlineModeUserIdentity } = reduxStore.getState().offlineMode;
        const offlineDataUserId = offlineModeUserIdentity;
        const updatedCallParticipants = offlineDataUserId.filter((identity) => identity !== message?.identity);
        if (updatedCallParticipants.length === 0) {
            CALL_DATA.isOfflineModeActive = false; // Reset offline mode flag if no participants left
        }
        reduxStore.dispatch(setOfflineModeUserIdentity(updatedCallParticipants));
    }
};

const handleParticipantJoined = (message) => {
    // Handle participant joined notification
    // 202
    showToastMessages(message);
    const { totalUserCount, activeuserlist } = reduxStore.getState().commonReducer;
    if (totalUserCount < message.totalusercount && !activeuserlist.hasOwnProperty(message.identity)) {
        const copyActiveuserlist = cloneDeep(message.activeuserlist);
        reduxStore.dispatch(setActiveuserlist(copyActiveuserlist));
        reduxStore.dispatch(setTotalUserCount(parseInt(message.totalusercount)));
        const index = parseInt(copyActiveuserlist[CALL_DATA.localIdentity]);
        reduxStore.dispatch(setOwnIndex(index));
        reduxStore.dispatch(setNewActiveUserlist(copyActiveuserlist));
    }
    if (!message.isAgent && message.guestName !== "") {
        const updatedList = {
            ...reduxStore.getState().commonReducer.newActiveUserList,
            [message.identity]: message.guestName,
        };

        reduxStore.dispatch(setNewActiveUserlist(updatedList));
    }
    if (dualStreamEnabled()) {
        updateParticipantNames(); // need to handle on dual stream
    }
    if (CALL_DATA.participantUserName) {
        const updatedList = {
            ...reduxStore.getState().commonReducer.newActiveUserList,
            [CALL_DATA.localIdentity]: CALL_DATA.participantUserName,
        };
        reduxStore.dispatch(setNewActiveUserlist(updatedList));
    }
    addCallParticipant(message, "notification");
    showLatLongForStreaming();
};

const handleRemoveParticipantByHost = (message) => {
    // Handle remove participant by host notification
    LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "GUEST_RECEIVE_REMOVE_PARTICIPANT", {
        remove_user_identity: message?.remove_user_identity,
        rejoin_not_allowed: message?.rejoin_not_allowed,
        status: message?.status,
        ALL_PARTICIPANT_DISCONNECT: "true",
    });
    if (CALL_DATA.localIdentity === message?.remove_user_identity || message?.status == "2") {
        // Call the end call function if the local user and data track identity match.
        const localisedValues = Localize[PublicVariables.currentLanguageObj.languageCode];
        const removeRejoinData = {
            rejoinNotAllowed: message?.rejoin_not_allowed,
            sessionId: GLOBAL_MEETING_DATA.sessionId,
        };
        storage.set(LOCAL_STORAGE_KEYS.NOT_ALLOWED_TO_REJOIN_PARTICIPANT, removeRejoinData);
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "Rejoin_Not_Allowed_set_localstorage_value", removeRejoinData);
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "END_CALL_DATA_TRACK_RECEIVED", {
            ENDCALL: "true",
            rejoin_not_allowed: message.rejoin_not_allowed,
        });
        handleEndCallFunc();
        if (message.rejoin_not_allowed === ENABLED) {
            CALL_DATA.rejoinPopupNotShow = true;
            CustomToast.info(localisedValues?.you_have_been_removed_from_the_call_by_the_host_and_cannot_rejoin_now);
        } else {
            CustomToast.info(localisedValues?.host_removed_you_from_the_call);
        }
    }
};

const handleMuteUnmuteAudioByHost = (message) => {
    // Handle audio On Off participant by host notification
    const { startLocalAudio } = reduxStore.getState().twilioEvents;
    const localisedValues = Localize[PublicVariables.currentLanguageObj.languageCode];
    if (CALL_DATA.localIdentity === message?.mute_unmute_identity) {
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "GUEST_RECEIVE_MUTE_UNMUTE_PARTICIPANT_BY_HOST", {
            mute_unmute_identity: message?.mute_unmute_identity,
            status: message?.status,
            startLocalAudio: startLocalAudio,
        });
        const { audioStartNotificationReceivedFromHostModalOpen } = reduxStore.getState().commonReducer;
        if (startLocalAudio) {
            CustomToast.info(localisedValues?.host_muted_your_microphone);
            reduxStore.dispatch(setIsAudioButtonClickDisable(true)); // disable audio button while it create a local audio track
            handleToggleAudio();
            return;
        }

        if (!audioStartNotificationReceivedFromHostModalOpen) {
            LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "GUEST_RECEIVE_UNMUTE_MIC_NOTIFICATION_BY_HOST_MODAL_OPEN", "true");
            reduxStore.dispatch(setAudioStartNotificationReceivedFromHostModalOpen(true));
        }
    }
    if (message?.status == "2") {
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "GUEST_RECEIVE_MUTE_UNMUTE_PARTICIPANT_BY_HOST", {
            mute_unmute_identity: message?.mute_unmute_identity,
            status: message?.status,
            startLocalAudio: startLocalAudio,
            ALL_MICS_OFF: "true",
        });
        if (startLocalAudio) {
            reduxStore.dispatch(setIsAudioButtonClickDisable(true)); // disable audio button while it create a local audio track
            handleToggleAudio();
            CustomToast.info(localisedValues?.host_muted_your_microphone);
        }
    }
};

const handleRequestToAgentStartAudioOrVideo = (message) => {
    if (GLOBAL_MEETING_DATA.isAgent) {
        const { requestMicCameraModalsData } = reduxStore.getState().commonReducer;
        const requestType = message.request_type == "1" ? "Mic" : "Camera";
        const exists = requestMicCameraModalsData
            ?.slice()
            ?.some((item) => item.identity === message.identity && item.request_type === message.request_type);

        if (!exists) {
            const updatedModals = [...requestMicCameraModalsData, message];
            reduxStore.dispatch(setRequestMicCameraModalsData(updatedModals));
            LogFirebase(FIREBASE_EVENT_CATEGORY.REQUEST_MIC_CAMERA, "requested_toast_identity", {
                identity: message.identity,
                requestType: requestType,
            });
        }
        LogFirebase(FIREBASE_EVENT_CATEGORY.REQUEST_MIC_CAMERA, "is_requested_toast_exists", {
            isExists: exists,
            identity: message.identity,
            requestType: requestType,
        });
    }
};

const handleMicPermissionResponseByAgent = (message) => {
    if (CALL_DATA.localIdentity === message.request_user_identity) {
        const { startLocalAudio } = reduxStore.getState().twilioEvents;

        if (message.mic_request_permission_status === DISABLE && !startLocalAudio) {
            // 0 for Rejected
            const localizedValues = Localize[PublicVariables.currentLanguageObj.languageCode];
            const waitingToastText =
                localizedValues?.microphone_request_denied + " " + localizedValues?.click_the_mic_icon_if_you_need_to_request_again;
            CustomToast.info(waitingToastText);
        }
        if (message.mic_request_permission_status === ENABLED && !startLocalAudio) {
            // 1 for Accepted
            reduxStore.dispatch(setIsAudioButtonClickDisable(true)); // disable audio button(button click variable)
            handleToggleAudio();
        }
        toast.dismiss(CALL_DATA.localIdentity + "1"); // 1 mic, 2 Camera, remove waiting toast
    }
};

const handleCameraPermissionResponseByAgent = (message) => {
    if (CALL_DATA.localIdentity === message.request_user_identity) {
        const { startLocalVideo, streamingPartiIdentity } = reduxStore.getState().twilioEvents;
        const { expandView } = reduxStore.getState().commonReducer;
        if (message.camera_request_permission_status === DISABLE && !startLocalVideo) {
            // 0 for Rejected
            const localizedValues = Localize[PublicVariables.currentLanguageObj.languageCode];
            const waitingToastText =
                localizedValues?.camera_request_denied + " " + localizedValues?.click_the_camera_icon_if_you_need_to_request_again;
            CustomToast.info(waitingToastText);
        }
        if (message.camera_request_permission_status === ENABLED && !startLocalVideo) {
            // 1 for Accepted
            const isLocalUserStreaming = streamingPartiIdentity === CALL_DATA.localIdentity;
            if (dualStreamEnabled() && expandView && isLocalUserStreaming) {
                // it is from handleStartStopVideo video function, no need to other conditions
                showGridView(CALL_DATA.localIdentity, true);
            }
            performStartStopVideo();
        }
        toast.dismiss(CALL_DATA.localIdentity + "2"); // 1 mic, 2 Camera, remove waiting toast
    }
};

const handleStartStopVideoByHost = (message) => {
    // Handle start stop video by host notification
    const { startLocalVideo } = reduxStore.getState().twilioEvents;
    const localisedValues = Localize[PublicVariables.currentLanguageObj.languageCode];

    if (CALL_DATA.localIdentity === message?.video_start_stop_identity) {
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "GUEST_RECEIVE_VIDEO_START_STOP_PARTICIPANT_BY_HOST", {
            video_start_stop_identity: message?.video_start_stop_identity,
            status: message?.status,
            startLocalVideo: startLocalVideo,
        });
        const { videoStartNotificationReceivedFromHostModalOpen } = reduxStore.getState().commonReducer;
        if (startLocalVideo) {
            handleStartStopVideo();
            CustomToast.info(localisedValues?.host_turned_off_your_camera);
            return;
        }
        if (!videoStartNotificationReceivedFromHostModalOpen) {
            LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "GUEST_RECEIVE_VIDEO_START_NOTIFICATION_BY_HOST_MODAL", "true");
            reduxStore.dispatch(setVideoStartNotificationReceivedFromHostModalOpen(true));
        }
    }

    if (message?.status == "2") {
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "GUEST_RECEIVE_VIDEO_START_STOP_PARTICIPANT_BY_HOST", {
            video_start_stop_identity: message?.video_start_stop_identity,
            status: message?.status,
            startLocalVideo: startLocalVideo,
            ALL_CAM_OFF: "true",
        });
        if (startLocalVideo) {
            handleStartStopVideo();
            CustomToast.info(localisedValues?.host_turned_off_your_camera);
        }
    }
};

const handleStartStopScreenshareByHost = (message) => {
    // Handle start stop screenshare by host notification
    if (CALL_DATA.localIdentity === message?.screenshare_start_stop_identity) {
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "GUEST_RECEIVE_SCREEN_SHARE_START_PARTICIPANT_BY_HOST", {
            screenshare_start_stop_identity: message?.screenshare_start_stop_identity,
            status: message?.status,
        });
        const { screenShareStartNotificationReceivedFromHostModalOpen } = reduxStore.getState().commonReducer;
        if (!screenShareStartNotificationReceivedFromHostModalOpen) {
            LogFirebase(
                FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS,
                "GUEST_RECEIVE_START_SCREEN_SHARE_NOTIFICATION_BY_HOST_MODAL_OPEN",
                "true"
            );
            reduxStore.dispatch(setScreenShareStartNotificationReceivedFromHostModalOpen(true));
        }
    }
};

const handleChatMessage = (message) => {
    // Handle chat message notification
    chatService.handleIncomingMessage(message);
};

const handleMicrophonePermission = (message) => {
    // Handle microphone permission notification
    if (GLOBAL_MEETING_DATA.isAgent) {
        updateParticipantAudioInfo(message);
    }
};

const handleCameraPermission = (message) => {
    // Handle camera permission notification
    if (GLOBAL_MEETING_DATA.isAgent) {
        updateParticipantVideoInfo(message);
    }
};

const handleVideoQuality = (message) => {
    // Handle video quality notification
    changeVideoQuality(message.video_quality);
};

const handleZoomLevelChange = (message) => {
    // Handle zoom level change notification
    zoomService.callToggleZoom(message);
};
const handleVideoScreenShareTrack = (message) => {
    // Handle video screen share status track
    handleReceiveVideoScreenShareDataTrack(message);
};

const handleOCRRequestToStreamingUser = (message) => {
    extractTextService.handleOCRRequestToStreamingUser(message);
};

const handleOCRRequestFromStreamingUser = (message) => {
    extractTextService.handleOCRRequestFromStreamingUser(message);
};

const handleTakePhotoRequestToStreamingUser = (message) => {
    takePhotoService.takePhotoRequestToStreamingUser(message);
};

const handleTakePhotoRequestFromStreamingUser = (message) => {
    takePhotoService.handleTakePhotoRequestFromStreamingUser(message);
};

const handleGuestDeviceBatteryInfo = (message) => {
    if (message.batteryVal < BATTERY_CRITICAL_VALUE) {
        batteryInfoService.showDeviceBatteryLowMessage("remote", message);
    } else if (message.batteryVal >= BATTERY_CRITICAL_VALUE) {
        batteryInfoService.hideDeviceBatteryLowMessage("remote", message);
    }
};

const handleNetworkInformation = (msg) => {
    const { identity, networkType = "", networkSpeed = "" } = msg;
    handleUpdateUserNetworkType(identity, networkType, networkSpeed);
};

const handleMarkupRequestToStreamingUser = (message) => {
    markupService.handleMarkupRequestToStreamingUser(message);
};
const handleMarkupRequestFromStreamingUser = (message) => {
    markupService.handleMarkupRequestFromStreamingUser(message);
};
